const util = {
    // Converts numbers with exponents to a string without exponents
    noExponents(val: number): string {
        const data = String(val).split(/[eE]/);
        
        // If the number doesn't contain exponents, return it directly
        if (data.length === 1) return data[0];

        const sign = val < 0 ? '-' : '';
        const base = data[0].replace('.', '');
        const exponent = Number(data[1]);
        let result = '';

        // If the exponent is negative
        if (exponent < 0) {
            result = sign + '0.' + '0'.repeat(Math.abs(exponent) - 1) + base;
        } else {
            result = base + '0'.repeat(exponent);
        }

        return result;
    }
};

export default util;


/* // utils/web3.ts

const util = {
    // Your functions here
    noExponents(val: number): string {
        
        const data = String(val).split(/[eE]/);

        if (data.length === 1) return data[0];

        let z = '';
        const sign = val < 0 ? '-' : '';
        const str = data[0].replace('.', '');
        let mag = Number(data[1]) + 1;

        if (mag < 0) {
            z = sign + '0.';
            while (mag++) z += '0';
            return z + str.replace(/^\-/, '');
        }

        mag -= str.length;
        while (mag-- > 0) z += '0';

        return str + z;
    }
};

export default util;
 */